import * as React from "react"
import { Input } from "./input"
import { cn } from "@/lib/utils"

export interface TimePickerProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  onChange: (value: string) => void
}

export function TimePicker({
  className,
  onChange,
  value,
  ...props
}: TimePickerProps) {
  // Handle time input changes
  const handleTimeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    // Use the HTML5 time input validation
    onChange(value)
  }

  return (
    <Input
      type="time"
      className={cn("flex-1", className)}
      value={value}
      onChange={handleTimeChange}
      {...props}
    />
  )
}
